import { atom } from 'jotai';

/**
 * controls whether or not the widget is open
 */
export const openAtom = atom<boolean>(false);
